import "./App.css";
import DetailPage from "./page/detailpage";
import Homepage from "./page/homepage";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Header from "./components/header/header";
import Footer from "./components/footer/footer";
import axios from "axios";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setMovie } from "./Redux/Action";

function App() {
  const dispatch = useDispatch();
  const fetchMovie = async () => {
    const response = await axios.get(
      `https://moviesteamd.herokuapp.com/api/v1/movie`,
    );
    // .catch((err)=>{
    //     console.log('err', err)
    // })
    //console.log(response)
    console.log(response);
    dispatch(setMovie(response.data.data.results));
  };

  useEffect(() => {
    fetchMovie();
  }, []);

  return (
    <BrowserRouter>
      <div>
        <Header />
        <Switch>
          <Route exact path="/" component={Homepage} />
          <Route exact path="/detail_page/:id" component={DetailPage} />
        </Switch>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
